export type RawSseMessage = {
  event: string;
  data: string;
};

/**
 * Incrementally reads an HTTP response body and yields parsed SSE messages.
 * Each message is dispatched when a blank line terminates an event block.
 */
export async function* parseSupportTicketSseStreamMessage(
  reader: ReadableStreamDefaultReader<Uint8Array>,
): AsyncGenerator<RawSseMessage, void, void> {
  const decoder = new TextDecoder();
  let buffer = "";
  let currentEvent: string | null = null;
  let dataLines: string[] = [];

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        const trimmed = line.replace(/\r$/, "");

        if (trimmed === "") {
          if (dataLines.length > 0) {
            yield {
              event: currentEvent ?? "message",
              data: dataLines.join("\n"),
            };
          }
          currentEvent = null;
          dataLines = [];
          continue;
        }

        if (trimmed.startsWith("event:")) {
          currentEvent = trimmed.slice(6).trim();
          continue;
        }

        if (trimmed.startsWith("data:")) {
          let payload = trimmed.slice(5);
          if (payload.startsWith(" ")) {
            payload = payload.slice(1);
          }
          dataLines.push(payload);
        }
      }
    }

    if (dataLines.length > 0) {
      yield {
        event: currentEvent ?? "message",
        data: dataLines.join("\n"),
      };
    }
  } finally {
    reader.releaseLock();
  }
}
